import React from 'react';
import { mergeClassNames } from '../../style';
import { ReactComponent as CheckmarkIcon } from '../../../assets/icons/checkmark-icon.svg';
import { ParagraphMini } from '../typography';

export interface Item<T = string> {
  id: T;
  label: string;
}

export interface ToggleItemProps extends Item {
  isSelected: boolean;
  onSelect: MultiToggleProps['onSelect'];
  isFirstElement: boolean;
  isLastElement: boolean;
}

export interface MultiToggleProps {
  items: Item[];
  onSelect: (key: Item['id']) => void;
  selectedItemKey?: Item['id'];
}

const ToggleItem = ({
  id,
  label,
  onSelect,
  isSelected,
  isFirstElement,
  isLastElement,
}: ToggleItemProps): JSX.Element => {
  const buttonClass = mergeClassNames([
    { className: 'text-center title-wrapper settings-modal__radio-control' },
    { className: 'settings-modal__radio-control--outer-left', include: isFirstElement },
    { className: 'settings-modal__radio-control--outer-right', include: isLastElement },
    { className: 'active', include: isSelected },
    { className: 'bg-white', include: !isSelected },
  ]);

  return (
    <button className={buttonClass} onClick={() => onSelect(id)} type="button" tabIndex={0}>
      <input type="radio" name="none" value="none" checked={isSelected} onChange={() => {}} />
      <CheckmarkIcon />
      <ParagraphMini className="title m-0 ms-2">{label}</ParagraphMini>
    </button>
  );
};

export const MultiToggle = ({ items, onSelect, selectedItemKey }: MultiToggleProps): JSX.Element => {
  return (
    <div className="settings-modal__control-wrapper">
      {items.map((item, index) => (
        <ToggleItem
          key={item.id}
          id={item.id}
          isSelected={item.id === selectedItemKey}
          label={item.label}
          onSelect={onSelect}
          isFirstElement={index === 0}
          isLastElement={index === items.length - 1}
        />
      ))}
    </div>
  );
};
